export type PhmReloadType = 'default' | 'PG51Added'

export function reloadMsg(type: PhmReloadType) {
  return `reload-${type}`
}

export function isPhmReloadMsg(event: MessageEvent): event is MessageEvent {
  return typeof event.data === 'string' && event.data.startsWith('reload-')
}

export function getPhmReloadType(event: MessageEvent): PhmReloadType | undefined {
  if (!isPhmReloadMsg(event)) {
    return undefined
  }
  const type = event.data.substring('reload-'.length)
  if (type === 'default' || type === 'PG51Added') {
    return type
  }
  return undefined
}

const PATIENT_CREATED_PREFIX = 'patient-created-'

/**
 * Das Patientenportal meldet dem einbettenden Leistungserbringer-Portal, WELCHEN Patienten es gerade
 * angelegt hat. Gebraucht wird das nur im Einstieg „neue Patient:in": dort startet die Anlage ohne
 * `p`-Parameter, der Patient entsteht erst beim Absenden im Portal — ohne diese Meldung wuesste die
 * umgebende Seite bis zum naechsten Neuladen nicht, wer da entstanden ist.
 *
 * Bewusst dasselbe simple String-Protokoll wie `reloadMsg` (ein `postMessage` ohne Struktur): der
 * Empfaenger prueft den Praefix, alles andere faellt durch.
 */
export function patientCreatedMsg(patientId: string) {
  return `${PATIENT_CREATED_PREFIX}${patientId}`
}

export function getCreatedPatientId(event: MessageEvent): string | undefined {
  if (typeof event.data !== 'string' || !event.data.startsWith(PATIENT_CREATED_PREFIX)) {
    return undefined
  }
  return event.data.substring(PATIENT_CREATED_PREFIX.length) || undefined
}
